import { anniversaryIn, completedYears, parseIsoDate } from '../lib/isoDate';

/**
 * 社員の生年月日・勤務開始日の検証規則(純粋関数)。
 * 旧仕様の「年齢 15..80」「経験年数 0..60」を日付の範囲で表す。`today` が null のときは時計に依存しない規則だけを見る。
 */

export const MIN_BIRTH_DATE = '1900-01-01';
export const MIN_STAFF_AGE = 15;
export const MAX_STAFF_AGE = 80;
export const MAX_EXPERIENCE_YEARS = 60;

export const DATE_FORMAT_MESSAGE = '日付は YYYY-MM-DD の形式で入力してください';
const FUTURE_MESSAGE = '未来の日付は指定できません';

/** 1 つの日付欄の問題(なければ null)。`parseIsoDate` に通らなければ形式エラー。 */
export const birthDateIssue = (value: string, today: string | null): string | null => {
  if (parseIsoDate(value) === null) return DATE_FORMAT_MESSAGE;
  if (value < MIN_BIRTH_DATE) return `${MIN_BIRTH_DATE}以降の日付を入力してください`;
  if (today === null) return null;
  if (value > today) return FUTURE_MESSAGE;
  const age = completedYears(value, today);
  if (age !== null && age < MIN_STAFF_AGE) return `${MIN_STAFF_AGE}歳以上である必要があります`;
  if (age !== null && age > MAX_STAFF_AGE) return `${MAX_STAFF_AGE}歳以下である必要があります`;
  return null;
};

export const workStartDateIssue = (value: string, today: string | null): string | null => {
  if (parseIsoDate(value) === null) return DATE_FORMAT_MESSAGE;
  if (today === null) return null;
  if (value > today) return FUTURE_MESSAGE;
  const years = completedYears(value, today);
  return years !== null && years > MAX_EXPERIENCE_YEARS
    ? `勤務開始日は${MAX_EXPERIENCE_YEARS}年以内の日付にしてください`
    : null;
};

export const WORK_START_BEFORE_ADULT_MESSAGE = `勤務開始日は生年月日の${MIN_STAFF_AGE}歳の誕生日以降の日付にしてください`;

/** 勤務開始日と生年月日の前後関係(どちらかが無い・不正なら null)。 */
export const workStartVsBirthIssue = (
  birthDate: string | null,
  workStartDate: string | null,
): string | null => {
  const birth = birthDate === null ? null : parseIsoDate(birthDate);
  if (birth === null || workStartDate === null || parseIsoDate(workStartDate) === null) {
    return null;
  }
  // 生年月日より前も「15 歳の誕生日より前」に含まれるので、文言は 1 つにする(画面の即時表示と送信時で同じ)
  return workStartDate < anniversaryIn(birth, birth.year + MIN_STAFF_AGE)
    ? WORK_START_BEFORE_ADULT_MESSAGE
    : null;
};
